function HomeSlider() {
    const watchMobileWidth = window.matchMedia("(max-width: 640px)")
    const homeSlider = document.querySelector('#home-slider')
    const sliderContainer = document.querySelector('.home-hero-slider')
    const sliderScrollDown = document.querySelector('.home-hero-slider-button-down')

    if (homeSlider) {
        const slider = new Swiper(homeSlider, {
            loop: true,
            autoplay: {
                delay: 5000
            },
            speed: 1200,
            navigation: {
                nextEl: ".home-hero-slider-button-next",
                prevEl: ".home-hero-slider-button-prev"
            },
            simulateTouch: false
        })    
    
        slider.on('slideNextTransitionStart', function() {
            const activeSlideImage = document.querySelector('.swiper-slide-active .home-hero-slider__image')
            const activeSlideTitle = document.querySelector('.swiper-slide-active .home-hero-slider__content-title')
            const activeSlideContent = document.querySelector('.swiper-slide-active .home-hero-slider__content-content')
        
            if (!watchMobileWidth.matches) {
                gsap.from(activeSlideImage, {
                    x: 650,
                    duration: 1.6,
                    opacity: 0.5
                })
            
                gsap.from(activeSlideTitle, {
                    x: 550,
                    duration: 1.25,
                    opacity: 0.5
                })
            
                gsap.from(activeSlideContent, {
                    x: 550,
                    duration: 1.6,
                    opacity: 0.5
                })
            } 
    
            if (watchMobileWidth.matches) {
                gsap.from(activeSlideImage, {
                    x: 350,
                    duration: 1.6,
                    opacity: 0.5
                })
            
                gsap.from(activeSlideTitle, {
                    x: 250,
                    duration: 1.25,
                    opacity: 0.5
                })
            
                gsap.from(activeSlideContent, {
                    x: 250,
                    duration: 1.6,
                    opacity: 0.5
                })
            }   
        })
    
        slider.on('slidePrevTransitionStart', function() {
            const activeSlideImage = document.querySelector('.swiper-slide-active .home-hero-slider__image')
            const activeSlideTitle = document.querySelector('.swiper-slide-active .home-hero-slider__content-title')
            const activeSlideContent = document.querySelector('.swiper-slide-active .home-hero-slider__content-content')
        
            if (!watchMobileWidth.matches) {
                gsap.from(activeSlideImage, {
                    x: -100,
                    duration: 1,
                    opacity: 1
                })
            
                gsap.from(activeSlideTitle, {
                    x: -450,
                    duration: 1.25,
                    opacity: 0.5
                })
            
                gsap.from(activeSlideContent, {
                    x: -450,
                    duration: 1.6,
                    opacity: 0.5
                })
            }
    
            if (watchMobileWidth.matches) {
                gsap.from(activeSlideImage, {
                    x: -100,
                    duration: 1,
                    opacity: 1
                })
            
                gsap.from(activeSlideTitle, {
                    x: -350,
                    duration: 1.25,
                    opacity: 0.5
                })
            
                gsap.from(activeSlideContent, {
                    x: -350,
                    duration: 1.6,
                    opacity: 0.5
                })
            } 
        })
    }

    function scrollDown() {
        const homeSliderDimensions = sliderContainer.getBoundingClientRect()
        const homeSliderHeight = homeSliderDimensions.height
        gsap.to(window, {scrollTo: homeSliderHeight + 50})
    }

    if (sliderScrollDown) {
        sliderScrollDown.addEventListener('click', scrollDown)
    }
}

export default HomeSlider